export default "<p>\r\n  Your request has been sent!\r\n</p>\r\n"